// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const IssuingCategoriesTable: MarkdocTagRegistration = {
  tag: 'issuing-categories-table',
  component: 'IssuingCategoriesTable',
  attributes: {
    entries: {
      type: Array,
      default: [],
      required: true,
    },
  },
};
